module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce-img-1.429f8471.webp";